import { render } from "./twolevel.vue?vue&type=template&id=efd7344a&scoped=true"
import script from "./twolevel.vue?vue&type=script&lang=js"
export * from "./twolevel.vue?vue&type=script&lang=js"

import "./twolevel.vue?vue&type=style&index=0&id=efd7344a&scoped=true&lang=less"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd7344a"]])

export default __exports__